import {EmptyProps} from "../../common/empty/Empty.props";
import {ListColumnType, ListHeader} from "../../common/list/List.props";
import {getPaymentTypeName, PaymentType} from "./PaymentType";

export const HEADERS: ListHeader[] = [
    {
        type: ListColumnType.CHECK_BOX,
        name: "",
        key: ""
    },
    {
        type: ListColumnType.NORMAL,
        name: "결제번호",
        key: "paymentsNumber",
    },
    {
        type: ListColumnType.NORMAL,
        name: "결제일시",
        key: "paidAt"
    },
    {
        type: ListColumnType.NORMAL,
        name: "결제 항목",
        key: ["content", "isLicense"],
        convertToString: (content: string): string => content,
        paymentType: (isLicense: boolean): string => {
            return isLicense ? "라이선스" : "강의";
        }
    },
    {
        type: ListColumnType.NORMAL,
        name: "결제 종류",
        key: "isLicense",
        convertToString: (isLicense: boolean): string => {
            return isLicense ? "정기 결제" : "일반";
        }
    },
    {
        type: ListColumnType.NORMAL,
        name: "결제금액",
        key: "price",
        convertToString: (price: number): string => {
            return "₩" + price.toLocaleString();
        }
    },
    {
        type: ListColumnType.NORMAL,
        name: "사용자명",
        key: "userName",
    },
    {
        type: ListColumnType.NORMAL,
        name: "이메일",
        key: "email",
    },
    {
        type: ListColumnType.STATUS,
        name: "상태",
        key: "status",
        convertToString: (status: number): string => {
            return getPaymentTypeName(status) || "";
        },
        getCellStyle: (status: number): {} => {
            let color: string = "";

            if (status === PaymentType.CANCELED || status === PaymentType.REFUNDED) {
                color = "var(--gray400)";
            } else if (status === PaymentType.REFUND_REQUEST) {
                color = "var(--primary)";
            }

            return {
                color: color
            };
        }
    }
];

export const EMPTY_PROPS = (handleButtonClick: () => void): EmptyProps => {
    return {
        messageText: "강의 정보가 없습니다.",
        buttonText: "강의 추가 개설",
        handleButtonClick: handleButtonClick
    };
}